import {
	MDBBtn,
	MDBIcon,
	MDBModal,
	MDBModalBody,
	MDBModalContent,
	MDBModalDialog,
	MDBModalFooter,
	MDBModalHeader,
	MDBSpinner,
} from "mdb-react-ui-kit";
import React, { useContext, useEffect, useRef, useState } from "react";
import { api } from "../utils/axios";
import { JWTContext } from "../utils/context/JWTContext";
import TableModal from "./TableModal";
import "./chatBot.css";
import { ArrowUp, Edit, Maximize, Minus, Trash } from "iconsax-react";

function ChatBot() {
	const [basicModal, setBasicModal] = useState(false);
	const [message, setMessage] = useState("");
	const { setJWT } = useContext(JWTContext);
	const [messageList, setMessageList] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const listContainer = useRef();
	const [showPrompts, setShowPrompts] = useState(true);
	const chatBotRef = useRef();
	const textareaRef = useRef();
	// Modal state
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [selectedTable, setSelectedTable] = useState(null);
	// Maximize/minimize state
	const [isMaximized, setIsMaximized] = useState(false);

	const handleOpenTableModal = (tableData) => {
		setSelectedTable(tableData);
		setIsModalOpen(true);
	};

	const handleCloseTableModal = () => {
		setIsModalOpen(false);
		setSelectedTable(null);
	};

	// Toggle maximize/minimize
	const toggleMaximize = () => {
		setIsMaximized(!isMaximized);
	};

	const toggleOpen = () => setBasicModal(!basicModal);

	const prewrittenPrompts = [
		{
			brief: "مدیر محصول: ساخت جدول لیست وظایف",
			full: `به عنوان یک مدیر محصول خبره که هدف پروژه اش [هدف پروژه شما] است، این پروژه شامل [تعداد تیم ها] و نام آنها [نام تیم ها] و جزئیات تخصص و شرح شغل [تخصص و توضیحات تیم]، وابستگی بین وظایف [وابستگی ها] و ضرب الاجل ها [ضرب الاجل ها] است. این را به یک جدول لیست وظایف دقیق با ستون هایی برای اولویت، وابستگی، تیم ها و ضرب الاجل تبدیل کنید.`,
		},
		{
			brief: "مدیر پروژه چندتیمی: جدول وظایف",
			full: `به عنوان یک مدیر پروژه که چندین تیم از جمله [نام تیم] را با [جزئیات عملکردهای اصلی آنها] به عنوان عملکردهای اصلی رهبری می کند. دور نمای کلی اهداف پروژه [اهداف پروژه] است، با توجه به اهداف و دورنمای مطرح شده، وظایف برای هر تیم را در قالب جدولی ارائه دهید که اولویت، وابستگی، تیم ها و ضرب الاجل را نشان دهد.`,
		},
		{
			brief: "تمرکز بر وابستگی: وظایف با اولویت",
			full: `به عنوان یک مدیر پروژه، اهداف پروژه [اهداف پروژه] به صورت توالی گام ها و وابستگی ها [وابستگی ها] است. تسک های معین شده برای هر تیم [نام تیم ها]، اولویت آن ها [اولویت ها] و ضرب الاجل ها [ضرب الاجل ها] را در نظر بگیر. یک جدول که طبقه بندی و نظم دهی اطلاعات را با تاکید بر اولویت، وابستگی ها، تیم ها و ضرب الاجل ها می باشد را تحویل بده.`,
		},
		{
			brief: "تمرکز بر ددلاین: شکستن پروژه",
			full: `به عنوان یک مدیر پروژه که توضیحاتش در مورد جدول زمانی پروژه [توضیحات پروژه] بدین صورت، از جمله نقاط عطف و ضرب الاجل های حیاتی [ضرب الاجل ها] می باشد که این پروژه را به وظایف اختصاص داده شده به تیم های خاص تقسیم می کند [نام تیم] و اولویت کار و وابستگی ها را نشان می دهد، خروجی را در قالب یک جدول با ستون هایی برای اولویت، وابستگی، تیم ها و ضرب الاجل نشان بده.`,
		},
		{
			brief: "اولویت‌بندی وظایف: وظایف حیاتی و عادی",
			full: `به عنوان یک مدیر پروژه، وظایف پروژه خود را [اهداف پروژه] مشخص کنید، با تأکید بر اینکه کدام وظایف حیاتی هستند [وظایف حیاتی] و کدام یک می توانند منتظر بمانند [وظایف با اولویت پایین]. تیم های مسئول هر کار [نام تیم] و هر گونه وابستگی متقابل [وابستگی ها] را مشخص کنید. این را به جدولی با اولویت، وابستگی، تیم ها و ضرب الاجل تبدیل کنید.`,
		},
		{
			brief: "توزیع وظایف بین تیم‌ها",
			full: `به عنوان یک مدیر پروژه، جزئیات پروژه خود [اهداف پروژه] و تیم های درگیر [نام تیم]، از جمله مسئولیت های منحصر به فرد هر تیم را بیان کنید. نحوه توزیع وظایف، هر گونه وابستگی [وابستگی ها] و ضرب الاجل ها [ضرب الاجل ها] را توضیح دهید. این را به عنوان یک جدول، با اولویت، وابستگی، تیم ها و ضرب الاجل ها به عنوان ستون ارائه دهید.`,
		},
		{
			brief: "فرآیند چابک: اسپرینت و وظایف",
			full: `به عنوان یک مدیر پروژه، پروژه خود [اهداف پروژه] را در زمینه یک گردش کار چابک، از جمله وظایف فورس ماژور [وظایف فورس ماژور]، وظایف تیمی [نام تیم] و وابستگی ها [وابستگی ها] توصیف کنید. این را به جدولی با ستون هایی برای اولویت، وابستگی، تیم ها و ضرب الاجل ها تقسیم کنید.`,
		},
		{
			brief: "تحلیل جامع پروژه",
			full: `به عنوان یک مدیر پروژه، شرح جامعی از پروژه [اهداف پروژه] خود ارائه دهید، از جمله موارد تحویل دادنی، تیم ها [نام تیم]، وابستگی های بین وظیفه ها [وابستگی ها] و ضرب الاجل ها [ضرب الاجل ها]. این را در یک جدول دقیق با ستون هایی برای اولویت، وابستگی، تیم ها و ضرب الاجل سازماندهی کنید.`,
		},
	];

	const handlePromptClick = (fullPrompt) => {
		setMessage(fullPrompt);
		setShowPrompts(false);
	};

	// Function to show prompts again
	const showPromptsAgain = () => {
		setShowPrompts(true);
		setMessage("");
	};

	// Function to clear all messages and reset chatbot
	const clearAllMessages = () => {
		setMessageList([]);
		setMessage("");
		setShowPrompts(true);
		localStorage.removeItem("chatMessages");
	};

	// Auto-resize textarea function
	const adjustTextareaHeight = () => {
		if (textareaRef.current) {
			if (!message.trim()) {
				// If message is empty, set to minimum height
				textareaRef.current.style.height = "67px";
				return;
			}

			textareaRef.current.style.height = "auto";
			const scrollHeight = textareaRef.current.scrollHeight;
			const minHeight = 67;
			const maxHeight = 120;
			const newHeight = Math.max(minHeight, Math.min(scrollHeight, maxHeight));
			textareaRef.current.style.height = newHeight + "px";
		}
	};

	// Handle message change with auto-resize
	const handleMessageChange = (e) => {
		setMessage(e.target.value);
		// Auto-resize will be handled in useEffect
	};

	// Auto-resize when message changes
	useEffect(() => {
		adjustTextareaHeight();
	}, [message]);

	function parseTable(tableText) {
		const rows = tableText.trim().split("\n");
		const tableData = rows.map((row) =>
			row.split("|").map((cell) => cell.trim()),
		);
		return tableData;
	}

	function submitForm(e, prompt) {
		e.preventDefault();
		if (!message.trim() && !prompt) return;
		const newMessage = prompt || message;
		const updatedMessageList = [
			...messageList,
			{ text: newMessage, sender: "user" },
		];
		setMessageList(updatedMessageList);
		setMessage("");
		setIsLoading(true);
		localStorage.setItem("chatMessages", JSON.stringify(updatedMessageList));
		api
			.post(
				"/chat",
				{
					messages: [{ role: "user", content: newMessage }],
				},
				{
					headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
				},
			)
			.then((res) => {
				setIsLoading(false);
				const botResponseText = res.data.response;
				const isTable = botResponseText.includes("|");
				const botResponse = {
					sender: "bot",
					text: botResponseText,
					isTable,
					tableData: isTable ? parseTable(botResponseText) : null,
				};
				const updatedMessageListWithResponse = [
					...updatedMessageList,
					botResponse,
				];
				setMessageList(updatedMessageListWithResponse);
				localStorage.setItem(
					"chatMessages",
					JSON.stringify(updatedMessageListWithResponse),
				);
			})
			.catch((err) => {
				setIsLoading(false);
				setMessageList((prev) => [
					...prev,
					{
						sender: "bot",
						text: "مشکلی در ارسال پیام رخ داد. لطفاً دوباره تلاش کنید.",
					},
				]);
			});
	}

	useEffect(() => {
		const savedMessages = localStorage.getItem("chatMessages");
		if (savedMessages) {
			setMessageList(JSON.parse(savedMessages));
			setShowPrompts(false);
		}
	}, []);

	useEffect(() => {
		if (listContainer.current) {
			listContainer.current.scrollTop = listContainer.current.scrollHeight;
		}
	}, [messageList]);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (chatBotRef.current && !chatBotRef.current.contains(event.target)) {
				setBasicModal(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [chatBotRef]);

	return (
		<div className={`chatbot-box ${isMaximized ? "chatbot-maximized" : ""}`}>
			<div className="chatbot-messages">
				{/* Tiny control buttons */}
				<div className="chatbot-control-buttons">
					<button
						className="chatbot-tiny-btn chatbot-show-prompts-btn"
						onClick={showPromptsAgain}
						title="نمایش پرامپت‌ها"
					>
						<Edit size="15" color="#6B778C" variant="Linear" />
					</button>
					<button
						className="chatbot-tiny-btn chatbot-clear-btn"
						onClick={clearAllMessages}
						title="پاک کردن همه پیام‌ها"
					>
						<Trash size="15" color="#6B778C" variant="Linear" />
					</button>
					<button
						className="chatbot-tiny-btn chatbot-maximize-btn"
						onClick={toggleMaximize}
						title={isMaximized ? "کوچک کردن" : "بزرگ کردن"}
					>
						{isMaximized ? (
							<Minus size="15" color="#6B778C" variant="Linear" />
						) : (
							<Maximize size="15" color="#6B778C" variant="Linear" />
						)}
					</button>
				</div>

				{showPrompts && (
					<div className="prewritten-prompts">
						{prewrittenPrompts.map((prompt, index) => (
							<button
								key={index}
								className="chatbot-prompt-btn"
								onClick={() => handlePromptClick(prompt.full)}
							>
								{prompt.brief}
							</button>
						))}
					</div>
				)}
				{messageList.map((msg, i) =>
					msg.sender === "user" ? (
						<div className="chatbot-message chatbot-message-user" key={i}>
							{msg.text}
						</div>
					) : msg.isTable ? (
						<div className="chatbot-message chatbot-message-bot" key={i}>
							<div className="scrollable-table-container">
								<table className="table">
									<tbody>
										{msg.tableData.map((row, rowIndex) => (
											<tr key={rowIndex}>
												{row.map((cell, cellIndex) => (
													<td key={cellIndex}>{cell}</td>
												))}
											</tr>
										))}
									</tbody>
								</table>
							</div>
						</div>
					) : (
						<div className="chatbot-message chatbot-message-bot" key={i}>
							{msg.text}
						</div>
					),
				)}
				{isLoading && (
					<div className="chatbot-message chatbot-message-bot">
						<span className="chatbot-loading">...</span>
					</div>
				)}
				<div ref={listContainer} />
			</div>
			<form className="chatbot-input-row" onSubmit={(e) => submitForm(e, null)}>
				<textarea
					ref={textareaRef}
					className="chatbot-input"
					value={message}
					onChange={handleMessageChange}
					placeholder="با چت‌بات خود مکالمه کنید..."
				/>
				<button className="chatbot-send-btn" type="submit" disabled={isLoading}>
					<ArrowUp size="15" color="#fff" variant="Linear" />
				</button>
			</form>
			{/* TableModal for expanded table view (optional, can be added if needed) */}
			{/* <TableModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} tableData={selectedTable} /> */}
		</div>
	);
}

export default ChatBot;
